export const GET_IMPORT_PROPERTY_DROPDOWN = "GET_IMPORT_PROPERTY_DROPDOWN";
export const RESET_DATA = "RESET_DATA";
